import React, { useCallback } from 'react';

import { Typography } from '@vtblife/uikit';

import type { QuizStep } from '@search/graphql-typings';
import classname from '@search/classname/src';

import type { QuizStepResult, QuizStepItemResult } from '../service';

import QuizBuilderStepAnswer from './QuizBuilderStepAnswer';
import QuizBuilderStepButtons from './QuizBuilderStepButtons';

const cn = classname.bind(null, 'QuizBuilderStep');

export const QuizBuilderStep = ({
    stepData,
    totalSteps,
    currentStepNumber,
    stepResult,
    updateStepResult,
    goToNextStep,
    goToPrevStep,
    isMobile
}: {
    stepData: QuizStep;
    totalSteps: number;
    currentStepNumber: number;
    stepResult: QuizStepResult;
    updateStepResult: (value: { main: QuizStepItemResult } | { extra: QuizStepItemResult }) => void;
    goToNextStep: () => void;
    goToPrevStep: () => void;
    isMobile?: boolean;
}) => {
    const updateStepMainResult = useCallback((value: QuizStepItemResult) => {
        updateStepResult({
            main: value
        });
    }, [ updateStepResult ]);

    const updateStepExtraResult = useCallback((value: QuizStepItemResult) => {
        updateStepResult({
            extra: value
        });
    }, [ updateStepResult ]);

    return (
        <div className={cn()}>
            <div className={cn('content')}>
                <Typography
                    variant='secondary-alone'
                    color='secondary'
                    bold
                >
                    {
                        currentStepNumber === totalSteps ?
                            'последний вопрос' :
                            `вопрос ${currentStepNumber} из ${totalSteps}`
                    }
                </Typography>
                <Typography
                    variant='h2'
                    className={cn('title')}
                    responsive={isMobile}
                >
                    {stepData.title}
                </Typography>
                <Typography
                    variant='primary'
                    className={cn('subtitle')}
                >
                    {stepData.subtitle}
                </Typography>
                <div className={cn('answer')}>
                    <QuizBuilderStepAnswer
                        isMobile={isMobile}
                        updateStepItemResult={updateStepMainResult}
                        fieldName={stepData.internalName}
                        answer={stepData.answer}
                        stepItemResult={stepResult.main}
                    />
                </div>
                {
                    stepData.additional && stepResult.extra ? (
                        <>
                            <Typography
                                variant='secondary-alone'
                                className={cn('additional-title')}
                                bold
                            >
                                {stepData.additional.title}
                            </Typography>
                            <div className={cn('additional-answer')}>
                                <QuizBuilderStepAnswer
                                    isMobile={isMobile}
                                    updateStepItemResult={updateStepExtraResult}
                                    fieldName={stepData.additional.title}
                                    answer={stepData.additional.answer}
                                    stepItemResult={stepResult.extra}
                                />
                            </div>
                        </>
                    ) : null
                }
            </div>
            <div className={cn('buttons')}>
                <QuizBuilderStepButtons
                    isMobile={isMobile}
                    currentStepNumber={currentStepNumber}
                    totalSteps={totalSteps}
                    goToNextStep={goToNextStep}
                    goToPrevStep={goToPrevStep}
                />
            </div>
        </div>
    );
};
